import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=3e60bcf1&scoped=true&"
import script from "./VideoPlay.vue?vue&type=script&lang=ts&"
export * from "./VideoPlay.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=3e60bcf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60bcf1",
  null
  
)

export default component.exports